import { useEffect } from "react";
import { getCurrencyOfferByPeriod } from "../../../../../lib/Plans";

const useAutoSelectHighestPlan = ({
  plans,
  currentPeriod,
  selectedPlan,
  setSelectedPlan
}) => {
  useEffect(() => {
    const currentCurrencyOfferByPeriod = getCurrencyOfferByPeriod({
      currency_offers: selectedPlan?.currency_offers,
      period: currentPeriod
    });

    if (currentCurrencyOfferByPeriod) {
      return;
    }

    const plansList = plans ?? [];

    for (let i = plansList.length - 1; i >= 0; i--) {
      const plan = plansList[i];
      const planCurrencyOfferByPeriod = getCurrencyOfferByPeriod({
        currency_offers: plan.currency_offers,
        period: currentPeriod
      });

      if (planCurrencyOfferByPeriod) {
        setSelectedPlan(plan);
        break;
      }
    }
  }, [plans, selectedPlan, currentPeriod, setSelectedPlan]);
};

export default useAutoSelectHighestPlan;
